//
export default [
    {
        name: 'rut',
        type: 'rut-field',
        props: {
            label: 'Rut',
        },
    },
    {
        name: 'names',
        type: 'text-field',
        props: {
            label: 'Nombre(s)',
        },
    },
    {
        name: 'last_name1',
        type: 'text-field',
        props: {
            label: 'Primer apellido',
        },
    },
    {
        name: 'last_name2',
        type: 'text-field',
        props: {
            label: 'Segundo apellido',
        },
    },
    {
        name: 'email',
        type: 'text-field',
        props: {
            label: 'Correo electrónico(s)',
        },
    },
]
